<template>
	<div style="margin: 10px;">
		<el-card class="box-card">
			<el-row>
				<el-col :span="24">
					<el-form ref="Headform" :model="Headform" label-width="160px" >
						<el-form-item label="头像" prop="head">
							<el-upload :action="settings.apiBaseUrl+'api/v1/phone/upload'" list-type="picture-card" :limit="1"
							 :file-list="logoList" :on-exceed="handleLogo" :before-upload="beforePic" >
								<i class="el-icon-picture-outline"></i>
							</el-upload>
							<el-dialog :visible.sync="dialogVisible">
								<img width="100%" :src="dialogImageUrl" alt="">
							</el-dialog>
						</el-form-item>
					</el-form>
				</el-col>
			</el-row>
		</el-card>
	</div>
</template>

<script>
	import EditorBar from '../components/editor.vue'
	import request from '../assets/js/request.js'
	import qs from 'qs'
	export default {
		components: {
			EditorBar
		},
		data() {
			return {
				form: {
					account:'',
					oldPassword:'',
					newPassword:'',
					repPassword:''
				},
				rules: {
					oldPassword: [{
						required: true,
						message: '请输入原密码',
						trigger: 'blur'
					}],
					newPassword: [{
						required: true,
						message: '请输入新密码',
						trigger: 'blur'
					}],
					repPassword: [{
						required: true,
						message: '请输入重复密码',
						trigger: 'blur'
					}],
				},
			}
		},
		mounted() {},
		created() {
		},
		methods: {
			onSubmit(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						var obj = this;
						obj.$http({
							method: 'post',
							url: 'api/v1/user/info/update/passwd',
							data:{
								oldPassword:this.form.oldPassword,
								newPassword:this.form.newPassword,
								repPassword:this.form.repPassword,
							},
						}).then((res) => {
							if (res.data.status == 200) {
								obj.$message.success('修改成功,请重新登陆！')
								this.$router.push({
									path:'/'
								})
							} else {
								obj.$message.error(res.data.message)
							}
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});

			},
		}
	}
</script>

<style scoped="scoped">

	/deep/ .el-form-item__label {
		font-family: PingFang SC;
		font-weight: 400;
		color: #000000;
		line-height: 40px;
	}
</style>



// WEBPACK FOOTER //
// src/views/updateHead.vue